<h2 mat-dialog-title>Aviso</h2>
<mat-dialog-content class="mat-typography">
  <p *ngFor="let error of errors">{{error}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button 
    mat-raised-button 
    color="primary" 
    mat-dialog-close 
    cdkFocusInitial>Novo horário</button>
</mat-dialog-actions>